<!-- 书本详情 -->
<template>
  <div class="books">
    <div class="books_left">
    </div>
    <div class="books_center">
      <div class="books_top">
        <el-button type="primary" class="previous" @click="previousPage()" v-show="index > 0">上一页</el-button>
        <el-button type="info" disabled v-if="num > 0" class="disabled">{{ msg }}</el-button>
        <el-button @click="nextPage()" type="primary" v-if="num < 1" class="normality">{{ msg }}</el-button>
        <el-button type="primary" class="close" @click="close">关闭</el-button>
      </div>
      <div class="books_content" id="books_content">
        <img :src=src alt="">
      </div>
    </div>
    <div class="books_right">
    </div>
  </div>
</template>

<script>
import * as req from '@/utils/request'
import * as requestBook from '@/utils/requestBook'

export default {
  data () {
    return {
      index: 0,
      pageList: [],
      time: 5000,
      num: 0,
      addTime: 5
      // src: 'https://ss0.baidu.com/94o3dSag_xI4khGko9WTAnF6hhy/exp/w=500/sign=1303619e7df0f736d8fe4c013a54b382/b999a9014c086e06a5f268aa07087bf40bd1cbfd.jpg'
    }
  },
  computed: {
    bookType: function () {
      return this.$route.query.data.type
    },
    bookId: function () {
      return this.$route.query.data.id
    },
    fileName: function () {
      return this.$route.query.data.file_name
    },
    msg: function () {
      if (this.index >= this.pageList.length - 1 && this.num === 0) {
        return '已经是最后一页'
      }
      if (this.num > 0) {
        return this.num + '秒后可点击'
      }
      return '下一页'
    },
    // 获取当前页码图片链接
    src: function () {
      let index = this.index
      if (this.pageList.length < 1) {
        return ''
      }
      if (this.pageList.length < index) {
        index = 1
      }
      let booksUrl = this.global.bookUrl
      // let fileName = this.fileName
      return booksUrl + this.bookId + '/' + this.pageList[index].path
    }
  },
  methods: {
    // 上一页
    previousPage () {
      this.stopCountDown()
      document.getElementById('books_content').scrollTop = 0
      clearInterval(this.int)
      if (this.index === 0) {
        this.$message.error('已经是第一页')
        return
      }
      this.index--
    },
    // 下一页
    nextPage () {
      document.getElementById('books_content').scrollTop = 0
      if (this.index >= this.pageList.length - 1) {
        this.countDown()
        this.$message.error('已经是最后一页')
        return
      }
      this.index++
      this.recordBook()
    },
    // 倒计时
    countDown () {
      let res = this.global.getIsRead(this.bookId)
      // 已经读完的话, 就不用倒计时
      if (res && res.isOver) {
        this.num = 0
        return
      }
      this.stopCountDown()
      this.num = 0
      let _this = this
      this.int = setInterval(function () {
        _this.clock()
      }, 1000)
    },
    clock () {
      if (this.num > 0) {
        this.num--
        // return
      }
      if (this.num === 0) {
        this.stopCountDown()
        // 并更新本地学习记录
        this.recordBook()
      }
    },
    // 记录读书
    recordBook () {
      let studyRecordStr = this.global.user_info.study_record
      let studyRecord = this.global.stringToJson(studyRecordStr)
      let id = this.bookId
      let obj = {}
      if (this.index >= this.pageList.length - 1) {
        obj.isOver = true
      }
      obj.index = this.index
      obj.type = this.bookType
      studyRecord[id] = obj
      let updateData = {
        id: id,
        data: obj
      }
      let record = JSON.stringify(studyRecord)
      this.recordFinish(record, updateData)
    },
    // 停止倒计时
    stopCountDown () {
      clearInterval(this.int)
      // console.info('stop time', this.int)
      this.int = 0
      this.num = 0
    },
    // 更新学习记录和学习时长
    recordFinish (record, updateData) {
      // let beforeTime = this.global.user_info.learn_time
      // let learnTime = this.addTime + beforeTime
      // 更新本地的学习时长
      // this.global.user_info.learn_time = learnTime
      // 本地学习记录
      // this.global.user_info.study_record = record
      let msg = {}
      msg.id = this.global.user_info.id
      let data = {}
      // data.study_record = record
      // 将当前书本数据发送到后端判断是否更新
      data.updateData = updateData
      data.addTime = 5
      msg.data = data
      let sendData = {}
      sendData.data = msg
      sendData.fn = this.recordFinishfn
      sendData.vm = this
      req.Post('user/eidt_User', sendData)
    },
    recordFinishfn (data) {
      if (data === null) {
        alert('服务器未连接')
        return
      }
      if (data.err_code !== 0) {
        alert(data.err_msg)
      }
    },
    close () {
      this.stopCountDown()
      this.int = 0
      this.$router.push({path: '/index/menuIndex'})
    },
    // 获取书本数据
    getBooks () {
      let msg = {}
      msg.id = this.bookId
      msg.file_name = this.fileName
      let sendData = {}
      sendData.data = msg
      sendData.fn = this.getBooksfn
      sendData.vm = this
      // req.Post('fileMenuData/get_book', sendData)
      requestBook.Post('fileMenuData/get_book', sendData)
    },
    getBooksfn (data) {
      if (data === null) {
        alert('服务器未连接')
        window.location.href = window.$global.loginURL
        return
      }
      if (data.err_code !== 0) {
        // 没有书
        window.location.href = window.$global.loginURL
        return
      }
      let page = data.list
      let list = page.page_list
      this.pageList = list
      let res = this.global.getIsRead(this.bookId)
      if (res && res.index && !res.isOver) {
        this.index = res.index + 1
      }
      if (list.length > 0) {
        this.countDown()
      }
    }
  },
  created () {
  },
  // 路由进来前
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.getBooks()
    })
  },
  // 路由跳出后
  beforeRouteLeave (to, from, next) {
    this.stopCountDown()
    next()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.nextPage {
  width: 100px;
  height: 50px;
  background: #b4b4b4;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgb(255, 255, 255);
}

.clickable {
  background: rgb(64, 158, 255);
}

.books {
  width: 100%;
  height: 100%;
  display: flex;
  background: #cdcdcd;
}

.books_center {
  width: 50%;
  height: 100%;
}

.books_content {
  height: 92%;
  overflow-y: auto;
}

.books_top {
  height: 8%;
  width: 100%;
  display: flex;
  align-items: center;
  background-color: white;
  position: relative;
  top: 0;
}

.books_content > img {
  width: 100%;
}

.books_left {
  width: 25%;
  height: 100%;
}

.books_right {
  width: 25%;
  height: 100%;
}

.disabled {
  /* margin: auto; */
  position: absolute;
  left: 45%;
}

.normality {
  position: absolute;
  left: 45%;
}

.close {
  position: absolute;
  right: 0;
}

.previous {
  position: absolute;
  left: 0;
}
</style>



// WEBPACK FOOTER //
// src/page/books.vue